namespace Matrix.DataAudit {

	@Serenity.Decorators.responsive()
	@Serenity.Decorators.panel()
	export class SingleAccountHistoryDialog extends Serenity.TemplatedDialog<any> {

        public grid: SingleAccountHistoryGrid;

        constructor() {
            super();

			this.grid = new SingleAccountHistoryGrid(this.element.children());
        }

        protected getTemplate() {
			return "<div style='height: 100%; flex: 1 1 100%;'></div>";
        }
    }
}